/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentDetailsSourceOfMoneyViewModel } from './PaymentDetailsSourceOfMoneyViewModel';
import {
    PaymentDetailsSourceOfMoneyViewModelFromJSON,
    PaymentDetailsSourceOfMoneyViewModelFromJSONTyped,
    PaymentDetailsSourceOfMoneyViewModelToJSON,
} from './PaymentDetailsSourceOfMoneyViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsEFTExternalProviderViewModel
 */
export interface PaymentDetailsEFTExternalProviderViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsEFTExternalProviderViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsEFTExternalProviderViewModel
     */
    originatingSchemeId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsEFTExternalProviderViewModel
     */
    amount?: number;
    /**
     * 
     * @type {Array<PaymentDetailsSourceOfMoneyViewModel>}
     * @memberof PaymentDetailsEFTExternalProviderViewModel
     */
    sourcesOfMoney: Array<PaymentDetailsSourceOfMoneyViewModel>;
}

/**
 * Check if a given object implements the PaymentDetailsEFTExternalProviderViewModel interface.
 */
export function instanceOfPaymentDetailsEFTExternalProviderViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sourcesOfMoney" in value;

    return isInstance;
}

export function PaymentDetailsEFTExternalProviderViewModelFromJSON(json: any): PaymentDetailsEFTExternalProviderViewModel {
    return PaymentDetailsEFTExternalProviderViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsEFTExternalProviderViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsEFTExternalProviderViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'originatingSchemeId': !exists(json, 'OriginatingSchemeId') ? undefined : json['OriginatingSchemeId'],
        'amount': !exists(json, 'Amount') ? undefined : json['Amount'],
        'sourcesOfMoney': ((json['SourcesOfMoney'] as Array<any>).map(PaymentDetailsSourceOfMoneyViewModelFromJSON)),
    };
}

export function PaymentDetailsEFTExternalProviderViewModelToJSON(value?: PaymentDetailsEFTExternalProviderViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'OriginatingSchemeId': value.originatingSchemeId,
        'Amount': value.amount,
        'SourcesOfMoney': ((value.sourcesOfMoney as Array<any>).map(PaymentDetailsSourceOfMoneyViewModelToJSON)),
    };
}

